import { StandardEvents } from '@shopify/events';
document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  try {
    const result=event.promise?await event.promise:null;
    if(result?.detail?.didError)return;
    const sourceModal=event.target instanceof Element?event.target.closest('dialog:modal'):null;
    if(event.action==='add'){
      if(sourceModal?.open)sourceModal.addEventListener('close',()=>window.AnwraCart?.open(),{once:true});
      else await window.AnwraCart?.open();
    }else await window.AnwraCart?.refresh();
  }catch{/* Native product forms retain their own error messages. */}
});